var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEma1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Very unsure"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44 21.9997C44 34.1497 34.1811 43.9995 22.0693 43.9995C9.95703 43.9995 0.138648 34.1497 0.138648 21.9997C0.138648 9.84931 9.95703 0 22.0693 0C34.1811 0.000481606 44 9.84979 44 21.9997Z",
    fill: "#FFE14D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66219 22.087C4.35301 9.93561 9.81023 3.66318 19.1639 0.17395C8.35746 1.53882 0 10.79 0 21.9998C0 34.1503 9.81839 44 21.9307 44C23.9543 44 25.913 43.7236 27.7734 43.2088C26.8675 43.3229 25.9428 43.4298 25.0071 43.3822C14.9765 42.8702 4.97089 34.2331 4.66219 22.087Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.5711 32.7731C13.5711 28.1039 17.3446 24.318 22.0001 24.318C26.6556 24.318 30.4291 28.1034 30.4291 32.7731C30.4291 37.4427 26.6556 33.3284 22.0001 33.3284C17.3446 33.3284 13.5711 37.4427 13.5711 32.7731Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.1651 19.5895C15.1651 21.656 13.6802 23.3315 11.8487 23.3315C10.0181 23.3315 8.53312 21.656 8.53312 19.5895C8.53312 17.5229 10.0181 15.8469 11.8487 15.8469C13.6807 15.8469 15.1651 17.5224 15.1651 19.5895Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.2315 19.5895C35.2315 21.656 33.7466 23.3315 31.9155 23.3315C30.0839 23.3315 28.5995 21.656 28.5995 19.5895C28.5995 17.5229 30.0839 15.8469 31.9155 15.8469C33.7466 15.8469 35.2315 17.5224 35.2315 19.5895Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.036 13.9663C40.036 13.9663 34.9631 23.5984 40.5527 23.5984C44.0646 23.5987 42.9058 17.7149 40.036 13.9663Z",
    fill: "#A9BFE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.90605 12.6226C6.90605 12.6226 7.64299 12.4256 8.71215 12.2133C10.1553 11.9253 12.2034 11.6103 13.8544 11.7138C16.7268 11.894 14.6706 8.88633 9.71555 9.98439C4.7605 11.0825 5.62612 12.9236 6.90605 12.6226Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.8585 12.7271C36.8585 12.7271 36.1215 12.5301 35.0528 12.3177C33.6092 12.0297 31.5611 11.7147 29.9101 11.8183C27.0377 11.9984 29.0944 8.99077 34.0489 10.0888C39.0035 11.1869 38.1384 13.0281 36.8585 12.7271Z",
    fill: "#802E19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEma1);
export default __webpack_public_path__ + "static/media/ema1.cc1ef734371f16caee74e79a0c1c32eb.svg";
export { ForwardRef as ReactComponent };